import styled, { css, useTheme } from "styled-components";
import { ReactComponent as PlusIcon } from "../../assets/icons/plus.svg";
import { ReactComponent as CaretDown } from "../../assets/icons/Down.svg";
import { ReactComponent as HomeIcon } from "../../assets/icons/Programs.svg";
import { ReactComponent as MediaLibIcon } from "../../assets/icons/Media Library 2.svg";
// import { ReactComponent as CreditDBIcon } from "../../assets/Clio/ClioCreditLibrary.svg";
import { ReactComponent as EntriesIcon } from "../../assets/icons/Media Library.svg";
import { ReactComponent as CheckIcon } from "../../assets/icons/Check.svg";
import { ReactComponent as UserIcon } from "../../assets/icons/Person.svg";
import { ReactComponent as DownloadIcon } from "../../assets/icons/Download.svg";
import { ReactComponent as ClockIcon } from "../../assets/icons/Clock.svg";
import { ReactComponent as EditPencilIcon } from "../../assets/icons/Write.svg";
import { ReactComponent as CalendarIcon } from "../../assets/icons/calendar.svg";
import { ReactComponent as DragArrowsIcon } from "../../assets/icons/DragDrop.svg";
import { ReactComponent as ExpandArrowsIcon } from "../../assets/icons/Expand.svg";
import { ReactComponent as SearchIcon } from "../../assets/icons/Search.svg";
import { ReactComponent as EyeIcon } from "../../assets/icons/Preview.svg";
import { ReactComponent as TriangleIcon } from "../../assets/icons/Triangle.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/Close.svg";
import { ReactComponent as CloseLarge } from "../../assets/icons/CloseLarge.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/Trash.svg";
import { ReactComponent as InvalidIcon } from "../../assets/icons/invalid.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/Info.svg";
import { ReactComponent as InfoIcon2 } from "../../assets/icons/Info2.svg";
import { ReactComponent as CropIcon } from "../../assets/icons/Crop.svg";
import { ReactComponent as CopyIcon } from "../../assets/icons/Copy.svg";
import { ReactComponent as UploadIcon } from "../../assets/icons/Upload.svg";
import { ReactComponent as ExpandCaret } from "../../assets/icons/ExpandCaret.svg";
import { ReactComponent as PlayIcon } from "../../assets/icons/Play.svg";
import { ReactComponent as PauseCircleIcon } from "../../assets/icons/PauseCircle.svg";
import { ReactComponent as PauseIcon } from "../../assets/icons/Pause.svg";
import { ReactComponent as StopIcon } from "../../assets/icons/Stop.svg";
import { ReactComponent as LockIcon } from "../../assets/icons/Lock.svg";
import { ReactComponent as UnlockedIcon } from "../../assets/icons/Unlocked.svg";
import { ReactComponent as SidebarSettingsIcon } from "../../assets/icons/SideBarSettings.svg";
import { ReactComponent as SidebarLogoutIcon } from "../../assets/icons/SideBarLogout.svg";
import { ReactComponent as SidebarLibraryIcon } from "../../assets/icons/SideBarLibrary.svg";
import { ReactComponent as SidebarReportsIcon } from "../../assets/icons/SideBarReports.svg";
import { ReactComponent as SidebarJudgeIcon } from "../../assets/icons/SideBarJudge.svg";
import { ReactComponent as LibraryIcon } from "../../assets/icons/Library.svg";
// import { ReactComponent as ClioStatue } from "../../assets/Clio/ClioStatue.svg";
import { ReactComponent as HelpIcon } from "../../assets/icons/Help.svg";
import { ReactComponent as NotesIcon } from "../../assets/icons/Notes.svg";
import { ReactComponent as LinkIcon } from "../../assets/icons/link.svg";
import { ReactComponent as MediaIcon } from "../../assets/icons/Media.svg";
import { ReactComponent as PlayerIcon } from "../../assets/icons/Player.svg";
import { ReactComponent as FilterIcon } from "../../assets/icons/Filter.svg";
import { ReactComponent as StarIcon } from "../../assets/icons/Star.svg";
import { ReactComponent as ListIcon } from "../../assets/icons/List.svg";
import { ReactComponent as GridIcon } from "../../assets/icons/Grid.svg";
import { ReactComponent as PresentIcon } from "../../assets/icons/Present.svg";
import { ReactComponent as StopPresentIcon } from "../../assets/icons/StopPresenting.svg";
import { ReactComponent as ZoomIcon } from "../../assets/icons/Unzoom.svg";
import { ReactComponent as HideIcon } from "../../assets/icons/Hide.svg";
import { ReactComponent as DeselectIcon } from "../../assets/icons/Deselect.svg";
import { ReactComponent as TagIcon } from "../../assets/icons/Tag.svg";
import { ReactComponent as LikeIcon } from "../../assets/icons/Like.svg";
import { ReactComponent as LikedIcon } from "../../assets/icons/Liked.svg";
import { ReactComponent as FlagIcon } from "../../assets/icons/Flag.svg";
import { ReactComponent as FlaggedIcon } from "../../assets/icons/Flagged.svg";
import { ReactComponent as EditUserIcon } from "../../assets/icons/EditUser.svg";
import { ReactComponent as DocumentIcon } from "../../assets/icons/Doc.svg";
import { ReactComponent as EntryReview } from "../../assets/icons/EntryReview.svg";
import { ReactComponent as Cube } from "../../assets/icons/Cube.svg";

import { ReactComponent as DocPlay } from "../../assets/placeholders/DocPlay.svg";
import { ReactComponent as VideoPlay } from "../../assets/placeholders/VideoPlay.svg";
import { ReactComponent as AudioPlay } from "../../assets/placeholders/AudioPlay.svg";

// animated SVGs
import PlaySpinningIcon from "./AnimatedIcons/PlaySpinningIcon";
import PauseSpinningIcon from "./AnimatedIcons/PauseSpinningIcon";
import StopSpinningIcon from "./AnimatedIcons/StopSpinningIcon";

import AlertBlue from "../../assets/icons/alert-blue.png";
import AlertBlack from "../../assets/icons/alert-black.png";
import AlertGray from "../../assets/icons/alert-gray.png";
import AlertWhite from "../../assets/icons/alert-white.png";
import AlertGold from "../../assets/icons/alert-gold.png";
import { useHistory } from "react-router-dom";
import assetsConfig from "../../assetsConfig";
import React from "react";

export const IconWrapper = styled.span<IconWrapperProps>`
	cursor: pointer;

	${(p) =>
		p.defaultCursor &&
		css`
			cursor: default;
		`};

	${(p) =>
		p.readonly &&
		css`
			cursor: not-allowed;
		`};

	svg {
		width: ${(p) => p.width};
		height: ${(p) => p.height};

		${(p) =>
			p.rotation &&
			css`
				transform: ${`rotate(${p.rotation})`};
				transition: all 150ms ease;
			`};

		${(p) =>
			p.solidPathFill &&
			css`
				path {
					fill: ${p.color};
				}
			`};

		${(p) =>
			p.solidPathStroke &&
			css`
				path {
					stroke: ${p.color};
				}
			`};

		${(p) =>
			p.solidRect &&
			css`
				rect {
					fill: ${p.color};
				}
			`};

		${(p) =>
			p.solidRectStroke &&
			css`
				rect {
					stroke: ${p.color};
				}
			`};

		g {
			stroke: ${(p) => (!p.solidPathFill ? p.color : `transparent`)};
		}

		${(p) =>
			p.transparentGStroke &&
			css`
				g {
					stroke: transparent;
				}
			`};

		${(p) =>
			p.solidGStroke &&
			css`
				g {
					stroke: ${p.color};
				}
			`};

		${(p) =>
			p.solidGFill &&
			css`
				g {
					fill: ${p.color};
				}
			`};

		polygon {
			fill: ${(p) => (p.solidPolygon ? p.color : `transparent`)};
			stroke: ${(p) => (!p.solidPolygon ? p.color : `transparent`)};
		}

		${(p) =>
			p.solidLine &&
			css`
				line {
					stroke: ${p.color};
				}
			`};

		${(p) =>
			p.solidPolyline &&
			css`
				polyline {
					stroke: ${p.color};
				}
			`};
	}
`;

const getIcon = (icon: string, alt: string | undefined) => {
	switch (icon) {
		case "plus":
			return <PlusIcon title={alt} />;
		case "close":
			return <CloseIcon title={alt} />;
		case "closeLarge":
			return <CloseLarge title={alt} />;
		case "caret":
			return <CaretDown title={alt} />;
		case "expandCaret":
			return <ExpandCaret title={alt} />;
		case "alert-blue":
			return <img src={AlertBlue} alt={alt || "Alert"} />;
		case "alert-black":
			return <img src={AlertBlack} alt={alt || "Alert"} />;
		case "alert-gold":
			return <img src={AlertGold} alt={alt || "Alert"} />;
		case "alert-white":
			return <img src={AlertWhite} alt={alt || "Alert"} />;
		case "alert-gray":
			return <img src={AlertGray} alt={alt || "Alert"} />;
		case "home":
			return <HomeIcon title={alt} />;
		case "media-library":
			return <MediaLibIcon title={alt} />;
		case "credit-db":
			return assetsConfig.icons.creditLibrary;
		// <CreditDBIcon title={alt} />;
		case "entries":
			return <EntriesIcon title={alt} />;
		case "edit":
			return <EditPencilIcon title={alt} />;
		case "check":
			return <CheckIcon title={alt} />;
		case "user":
			return <UserIcon title={alt} />;
		case "clock":
			return <ClockIcon title={alt} />;
		case "download":
			return <DownloadIcon title={alt} />;
		case "calendar":
			return <CalendarIcon title={alt} />;
		case "eye":
			return <EyeIcon title={alt} />;
		case "triangle":
			return <TriangleIcon title={alt} />;
		case "search":
			return <SearchIcon title={alt} />;
		case "expand-arrows":
			return <ExpandArrowsIcon title={alt} />;
		case "drag-arrows":
			return <DragArrowsIcon title={alt} />;
		case "trash":
			return <TrashIcon title={alt} />;
		case "invalid":
			return <InvalidIcon title={alt} />;
		case "info":
			return <InfoIcon title={alt} />;
		case "info2":
			return <InfoIcon2 title={alt} />;
		case "crop":
			return <CropIcon title={alt} />;
		case "copy":
			return <CopyIcon title={alt} />;
		case "upload":
			return <UploadIcon title={alt} />;
		case "play":
			return <PlayIcon title={alt} />;
		case "pause":
			return <PauseIcon title={alt} />;
		case "pause-circle":
			return <PauseCircleIcon title={alt} />;
		case "pause-spinning":
			return <PauseSpinningIcon />;
		case "play-spinning":
			return <PlaySpinningIcon />;
		case "stop":
			return <StopIcon title={alt} />;
		case "stop-spinning":
			return <StopSpinningIcon />;
		case "lock":
			return <LockIcon title={alt} />;
		case "unlocked":
			return <UnlockedIcon title={alt} />;
		case "gear":
			return <SidebarSettingsIcon title={alt} />;
		case "logout":
			return <SidebarLogoutIcon title={alt} />;
		case "sidebarlibrary":
			return <SidebarLibraryIcon title={alt} />;
		case "reports":
			return <SidebarReportsIcon title={alt} />;
		case "judge":
			return <SidebarJudgeIcon title={alt} />;
		case "library":
			return <LibraryIcon title={alt} />;
		case "clio-statue":
			return assetsConfig.icons.statue;
		// return <ClioStatue />;
		case "help":
			return <HelpIcon />;
		case "notes":
			return <NotesIcon />;
		case "link":
			return <LinkIcon title={alt} />;
		case "document":
			return <DocumentIcon title={alt} />;
		case "doc-play":
			return <DocPlay title={alt} />;
		case "audio-play":
			return <AudioPlay title={alt} />;
		case "video-play":
			return <VideoPlay title={alt} />;
		case "media":
			return <MediaIcon title={alt} />;
		case "filter":
			return <FilterIcon title={alt} />;
		case "player":
			return <PlayerIcon title={alt} />;
		case "star":
			return <StarIcon title={alt} />;
		case "list":
			return <ListIcon title={alt} />;
		case "grid":
			return <GridIcon title={alt} />;
		case "present":
			return <PresentIcon title={alt} />;
		case "stop-present":
			return <StopPresentIcon title={alt} />;
		case "zoom":
			return <ZoomIcon title={alt} />;
		case "hide":
			return <HideIcon title={alt} />;
		case "tag":
			return <TagIcon title={alt} />;
		case "deselect":
			return <DeselectIcon title={alt} />;
		case "flag":
			return <FlagIcon title={alt} />;
		case "flagged":
			return <FlaggedIcon title={alt} />;
		case "like":
			return <LikeIcon title={alt} />;
		case "liked":
			return <LikedIcon title={alt} />;
		case "edit-user":
			return <EditUserIcon title={alt} />;
		case "entry-review":
			return <EntryReview title={alt} />;
		case "cube":
			return <Cube title={alt} />;

		default:
			return false;
	}
};

const Icon = (props: IconProps) => {
	const history = useHistory();
	const solidRect =
		props.icon === "entries" ||
		props.icon === "logout" ||
		props.icon === "list" ||
		props.icon === "pause-spinning" ||
		props.icon === "stop-spinning"
			? true
			: undefined;

	const solidRectStroke =
		props.icon === "reports" || props.icon === "entry-review"
			? true
			: undefined;

	const solidPathFill =
		props.icon === "home" ||
		props.icon === "invalid" ||
		props.icon === "calendar" ||
		props.icon === "play" ||
		props.icon === "pause-circle" ||
		props.icon === "play-spinning" ||
		props.icon === "stop-spinning" ||
		props.icon === "stop" ||
		props.icon === "judge" ||
		props.icon === "reports" ||
		props.icon === "clio-statue" ||
		props.icon === "star" ||
		props.icon === "cube"
			? true
			: undefined;

	const solidPathStroke =
		props.icon === "edit-user" ||
		props.icon === "entry-review" ||
		props.icon === "play-spinning" ||
		props.icon === "pause-spinning" ||
		props.icon === "stop-spinning"
			? true
			: undefined;

	const solidGStroke =
		props.icon === "home" ||
		props.icon === "liked" ||
		props.icon === "credit-db" ||
		props.icon === "edit-user"
			? true
			: undefined;

	const transparentGStroke =
		props.icon === "info" ||
		props.icon === "lock" ||
		props.icon === "help" ||
		props.icon === "filter" ||
		props.icon === "list" ||
		props.icon === "eye" ||
		props.icon === "tag" ||
		props.icon === "document"
			? true
			: undefined;

	const solidGFill =
		props.icon === "gear" ||
		props.icon === "info" ||
		props.icon === "lock" ||
		props.icon === "eye" ||
		props.icon === "help" ||
		props.icon === "liked" ||
		props.icon === "flagged" ||
		props.icon === "document" ||
		props.icon === "tag"
			? true
			: undefined;

	const solidPolygon =
		props.icon === "drag-arrows" ||
		props.icon === "calendar" ||
		props.icon === "edit" ||
		props.icon === "download" ||
		props.icon === "upload" ||
		props.icon === "logout" ||
		props.icon === "notes" ||
		props.icon === "edit-user"
			? true
			: undefined;

	const solidLine =
		props.icon === "edit" || props.icon === "reports" || props.icon === "pause"
			? true
			: undefined;

	const solidPolyline = props.icon === "logout" ? true : undefined;

	const handleClick = () => {
		props.onClick && props.onClick();
		props.to && history.push(props.to);
	};

	return (
		<div className={`${props.className ? props.className : ""}`}>
			<IconWrapper
				id={props.id}
				solidRect={solidRect}
				solidPathFill={solidPathFill}
				solidPathStroke={solidPathStroke}
				solidGStroke={solidGStroke}
				transparentGStroke={transparentGStroke}
				solidGFill={solidGFill}
				solidRectStroke={solidRectStroke}
				solidPolygon={solidPolygon}
				solidLine={solidLine}
				solidPolyline={solidPolyline}
				color={props.color}
				{...(props.width && {
					width: props.width,
				})}
				{...(props.height && {
					height: props.height,
				})}
				// temp set close icon to 20px
				{...(props.icon === "close" &&
					!props.width && {
						width: "20px",
					})}
				{...(props.icon === "close" &&
					!props.height && {
						height: "20px",
					})}
				{...(props.rotation && {
					rotation: props.rotation,
				})}
				{...(props.alt && {
					alt: props.alt,
				})}
				onClick={() => (props.readonly ? {} : handleClick())}
				readonly={props.readonly}
				defaultCursor={props.defaultCursor}
			>
				{getIcon(props.icon, props.alt)}
			</IconWrapper>
		</div>
	);
};

export default Icon;

interface IconWrapperProps {
	color: string;
	width?: string;
	height?: string;
	solidGStroke?: boolean;
	transparentGStroke?: boolean;
	solidGFill?: boolean;
	solidRect?: boolean;
	solidRectStroke?: boolean;
	solidPathFill?: boolean;
	solidPathStroke?: boolean;
	solidPolygon?: boolean;
	solidPolyline?: boolean;
	solidLine?: boolean;
	onClick?(): void;
	rotation?: string;
	isCollapsed?: boolean;
	readonly?: boolean;
	defaultCursor?: boolean;
}
interface IconProps {
	icon: string;
	// iconLeft?: string;
	// iconRight?: boolean;
	color: string;
	id?: string;
	to?: string;
	className?: string;
	width?: string;
	height?: string;
	// children?: React.ReactNode;
	onClick?(): void;
	rotation?: string;
	//isCollapsed?: boolean;
	readonly?: boolean;
	alt?: string;
	defaultCursor?: boolean;
}
